export default __webpack_public_path__ + "images/8b7882f6b4e458fce1770283be4beb59.png";